"use strict";
exports.__esModule = true;
var WIDGET_ICON_TYPES = {
    WHATSAPP: {
        label: 'Whatsapp',
        type: 'whatsapp',
    },
    MESSENGER: {
        label: 'Messenger',
        type: 'messenger',
    },
    INSTAGRAM: {
        label: 'Instagram',
        type: 'instagram',
    },
};
exports["default"] = WIDGET_ICON_TYPES;
